import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Constants from "config/Constants";
import { useInfoMessage } from "hooks";
import Mui5 from "components/mui5";
import { useTranslation } from "react-i18next";
import { useGroupActions } from "providers/GroupsProvider";
import DeleteGroupDialog from "features/Groups/DeleteGroupDialog";
import useBoolean from "hooks/useBoolean";
import type { Group } from "types/groups";

interface GroupDeleteActionProps {
  group: Pick<Group, "id" | "name">;
}

function GroupDeleteAction(props: GroupDeleteActionProps) {
  const { group } = props;
  const { value: open, toggle } = useBoolean(false);
  const { t } = useTranslation();
  const groupActions = useGroupActions();
  const infoMessage = useInfoMessage({ type: "error" });
  const navigate = useNavigate();

  const confirmGroupDeletion = useCallback(() => {
    groupActions
      .delete(group.id)
      .then(() => {
        navigate(`${Constants.routes.groups.route}`);
      })
      .catch(infoMessage);
  }, [groupActions, group.id, infoMessage, navigate]);

  return (
    <>
      <Mui5.Button onClick={toggle} variant="outlined" color="error">
        {t("group.delete_group_confirmation_button_text")}
      </Mui5.Button>
      <DeleteGroupDialog open={open} onClose={toggle} group={group} onConfirm={confirmGroupDeletion} />
    </>
  );
}

export default GroupDeleteAction;
